<div class="buscardor-tercero">
  <div *ngIf="loading" class="text-center">
    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
  <div *ngIf="!loading">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" *ngIf="!error">
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-2"></div>
        <div class="col-12 md:col-6 lg:col-3">
          <div class="div-form">
            <label
              >* {{ "PERFILCREZCAMOS.LBL_TIPODOCUMENTO" | translate }}</label
            >
            <p-dropdown
              id="idTipoDocumento"
              name="idTipoDocumento"
              [options]="lisTiposDocumentos"
              placeholder="{{ 'LBL_SELECCIONE' | translate }}"
              formControlName="idTipoDocumento"
              [disabled]="lisTiposDocumentos.length === 1"
            ></p-dropdown>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submitted && fControls.idTipoDocumento.invalid"
            >
              {{ "PERFILCREZCAMOS.LBL_TIPODOCUMENTO" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-3">
          <div class="div-form">
            <label
              >* {{ "PERFILCREZCAMOS.LBL_NUMERODOCUMENTO" | translate }}</label
            >
            <input
              type="text"
              pInputText
              id="numeroDocumento"
              name="numeroDocumento"
              autocomplete="off"
              formControlName="numeroDocumento"
              maxlength="13"
              document-type
              appTexto
              [sinLetras]="true"
              [sinCaracteres]="true"
              [sinComa]="true"
              [sinPunto]="true"
              [sinEspacio]="true"
              (blur)="validarCampo('numeroDocumento')"
            />
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submitted && fControls.numeroDocumento.invalid"
            >
              {{ "PERFILCREZCAMOS.LBL_NUMERODOCUMENTO" | translate }}
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-4">
          <div class="buscardor-tercero-options">
            <button
              type="submit"
              pButton
              class="p-button-success"
              icon="fa fa-filter"
              label="{{ 'PERFILCREZCAMOS.LBL_CONSULTAR' | translate }}"
            ></button>
            <button
              type="button"
              pButton
              class="button-comite"
              icon="fa fa-eraser"
              (click)="limpiarFormulario()"
              label="{{ 'PERFILCREZCAMOS.BTN_LIMPIAR' | translate }}"
            ></button>
          </div>
        </div>
      </div>
    </form>

    <div class="grid" *ngIf="error">
      <div class="col-12 lg:col-3"></div>
      <div class="col-12 lg:col-6">
        <div class="error-consulta">
          <h4>{{ "PERFILCREZCAMOS.LBL_PERFILCREZCAMOS" | translate }}</h4>
          <img src="../../../../assets/icons/perfil-crezcamos/buscador.gif" alt="icono-buscador" title="icono-buscador"/>
          <h3>{{ "PERFILCREZCAMOS.LBL_PERFILNOENCONTRADO" | translate }}</h3>
          <p>{{ "PERFILCREZCAMOS.LBL_NOINSCRITO" | translate }}</p>
          <p>{{ "PERFILCREZCAMOS.LBL_INICIARSOLICITUD" | translate }}</p>
          <div class="error-consulta-opciones">
            <button
              type="button"
              pButton
              (click)="redireccionar('/pys/gestion-comercial/flujo-venta-proceso')"
              icon="fa fa-plus"
              label="{{ 'PERFILCREZCAMOS.BTN_NUEVASOLICITUD' | translate }}"
            ></button>
            <button
              type="button"
              pButton
              (click)="redireccionar('/apl/simulador-credito')"
              *ngIf="permisoSimulado"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
              <path d="M15.1681 1.5H3.62773C2.73156 1.5 2 2.23156 2 3.12773V14.6224C2 15.5186 2.73156 16.2501 3.62773 16.2501H15.1681C16.0643 16.2501 16.7959 15.5186 16.7959 14.6224V3.12773C16.7959 2.23156 16.0643 1.5 15.1681 1.5ZM15.8814 14.6224C15.8814 15.0156 15.5614 15.3357 15.1681 15.3357H3.62773C3.23451 15.3357 2.91445 15.0156 2.91445 14.6224V3.12773C2.91445 2.73451 3.23451 2.41445 3.62773 2.41445H15.1681C15.5614 2.41445 15.8814 2.73451 15.8814 3.12773V14.6224Z" fill="white"/>
              <path d="M14.7011 3.13624H4.08889C3.83742 3.13624 3.63167 3.34199 3.63167 3.59346V6.64317C3.63167 6.89464 3.83742 7.10039 4.08889 7.10039H14.7011C14.9526 7.10039 15.1584 6.89464 15.1584 6.64317V3.59346C15.1584 3.34199 14.9526 3.13624 14.7011 3.13624ZM14.2439 6.18594H4.54612V4.05069H14.2439V6.18594Z" fill="white"/>
              <path d="M4.93853 7.8646H4.6645C4.09816 7.8646 3.63687 8.32589 3.63687 8.89223C3.63687 9.45856 4.09816 9.91985 4.6645 9.91985H4.93853C5.50486 9.91985 5.96615 9.45856 5.96615 8.89223C5.96615 8.32589 5.50486 7.8646 4.93853 7.8646ZM4.93853 9.01097H4.6645C4.59599 9.01097 4.54575 8.95617 4.54575 8.89223C4.54575 8.82828 4.60056 8.77348 4.6645 8.77348H4.93853C5.00704 8.77348 5.05728 8.82828 5.05728 8.89223C5.05728 8.95617 5.00247 9.01097 4.93853 9.01097Z" fill="white"/>
              <path d="M8.00195 7.8646H7.72792C7.16159 7.8646 6.7003 8.32589 6.7003 8.89223C6.7003 9.45856 7.16159 9.91985 7.72792 9.91985H8.00195C8.56829 9.91985 9.02958 9.45856 9.02958 8.89223C9.02958 8.32589 8.56829 7.8646 8.00195 7.8646ZM8.00195 9.01097H7.72792C7.65941 9.01097 7.60917 8.95617 7.60917 8.89223C7.60917 8.82828 7.66398 8.77348 7.72792 8.77348H8.00195C8.07046 8.77348 8.1207 8.82828 8.1207 8.89223C8.1207 8.95617 8.06589 9.01097 8.00195 9.01097Z" fill="white"/>
              <path d="M11.0654 7.8646H10.7913C10.225 7.8646 9.76372 8.32589 9.76372 8.89223C9.76372 9.45856 10.225 9.91985 10.7913 9.91985H11.0654C11.6317 9.91985 12.093 9.45856 12.093 8.89223C12.093 8.32589 11.6317 7.8646 11.0654 7.8646ZM11.0654 9.01097H10.7913C10.7228 9.01097 10.6726 8.95617 10.6726 8.89223C10.6726 8.82828 10.7274 8.77348 10.7913 8.77348H11.0654C11.1339 8.77348 11.1841 8.82828 11.1841 8.89223C11.1841 8.95617 11.1293 9.01097 11.0654 9.01097Z" fill="white"/>
              <path d="M14.1288 7.8646H13.8548C13.2884 7.8646 12.8271 8.32589 12.8271 8.89223C12.8271 9.45856 13.2884 9.91985 13.8548 9.91985H14.1288C14.6951 9.91985 15.1564 9.45856 15.1564 8.89223C15.1564 8.32589 14.6951 7.8646 14.1288 7.8646ZM14.1288 9.01097H13.8548C13.7863 9.01097 13.736 8.95617 13.736 8.89223C13.736 8.82828 13.7908 8.77348 13.8548 8.77348H14.1288C14.1973 8.77348 14.2476 8.82828 14.2476 8.89223C14.2476 8.95617 14.1927 9.01097 14.1288 9.01097Z" fill="white"/>
              <path d="M4.93853 10.3382H4.6645C4.09816 10.3382 3.63687 10.7995 3.63687 11.3658C3.63687 11.9322 4.09816 12.3934 4.6645 12.3934H4.93853C5.50486 12.3934 5.96615 11.9322 5.96615 11.3658C5.96615 10.7995 5.50486 10.3382 4.93853 10.3382ZM4.93853 11.4846H4.6645C4.59599 11.4846 4.54575 11.4298 4.54575 11.3658C4.54575 11.3019 4.60056 11.2471 4.6645 11.2471H4.93853C5.00704 11.2471 5.05728 11.3019 5.05728 11.3658C5.05728 11.4298 5.00247 11.4846 4.93853 11.4846Z" fill="white"/>
              <path d="M8.00195 10.3382H7.72792C7.16159 10.3382 6.7003 10.7995 6.7003 11.3658C6.7003 11.9322 7.16159 12.3934 7.72792 12.3934H8.00195C8.56829 12.3934 9.02958 11.9322 9.02958 11.3658C9.02958 10.7995 8.56829 10.3382 8.00195 10.3382ZM8.00195 11.4846H7.72792C7.65941 11.4846 7.60917 11.4298 7.60917 11.3658C7.60917 11.3019 7.66398 11.2471 7.72792 11.2471H8.00195C8.07046 11.2471 8.1207 11.3019 8.1207 11.3658C8.1207 11.4298 8.06589 11.4846 8.00195 11.4846Z" fill="white"/>
              <path d="M11.0654 10.3382H10.7913C10.225 10.3382 9.76372 10.7995 9.76372 11.3658C9.76372 11.9322 10.225 12.3934 10.7913 12.3934H11.0654C11.6317 12.3934 12.093 11.9322 12.093 11.3658C12.093 10.7995 11.6317 10.3382 11.0654 10.3382ZM11.0654 11.4846H10.7913C10.7228 11.4846 10.6726 11.4298 10.6726 11.3658C10.6726 11.3019 10.7274 11.2471 10.7913 11.2471H11.0654C11.1339 11.2471 11.1841 11.3019 11.1841 11.3658C11.1841 11.4298 11.1293 11.4846 11.0654 11.4846Z" fill="white"/>
              <path d="M4.93853 12.8118H4.6645C4.09816 12.8118 3.63687 13.2731 3.63687 13.8394C3.63687 14.4058 4.09816 14.867 4.6645 14.867H4.93853C5.50486 14.867 5.96615 14.4058 5.96615 13.8394C5.96615 13.2731 5.50486 12.8118 4.93853 12.8118ZM4.93853 13.9582H4.6645C4.59599 13.9582 4.54575 13.9034 4.54575 13.8394C4.54575 13.7755 4.60056 13.7207 4.6645 13.7207H4.93853C5.00704 13.7207 5.05728 13.7755 5.05728 13.8394C5.05728 13.9034 5.00247 13.9582 4.93853 13.9582Z" fill="white"/>
              <path d="M8.00195 12.8118H7.72792C7.16159 12.8118 6.7003 13.2731 6.7003 13.8394C6.7003 14.4058 7.16159 14.867 7.72792 14.867H8.00195C8.56829 14.867 9.02958 14.4058 9.02958 13.8394C9.02958 13.2731 8.56829 12.8118 8.00195 12.8118ZM8.00195 13.9582H7.72792C7.65941 13.9582 7.60917 13.9034 7.60917 13.8394C7.60917 13.7755 7.66398 13.7207 7.72792 13.7207H8.00195C8.07046 13.7207 8.1207 13.7755 8.1207 13.8394C8.1207 13.9034 8.06589 13.9582 8.00195 13.9582Z" fill="white"/>
              <path d="M11.0654 12.8118H10.7913C10.225 12.8118 9.76372 13.2731 9.76372 13.8394C9.76372 14.4058 10.225 14.867 10.7913 14.867H11.0654C11.6317 14.867 12.093 14.4058 12.093 13.8394C12.093 13.2731 11.6317 12.8118 11.0654 12.8118ZM11.0654 13.9582H10.7913C10.7228 13.9582 10.6726 13.9034 10.6726 13.8394C10.6726 13.7755 10.7274 13.7207 10.7913 13.7207H11.0654C11.1339 13.7207 11.1841 13.7755 11.1841 13.8394C11.1841 13.9034 11.1293 13.9582 11.0654 13.9582Z" fill="white"/>
              <path d="M14.1297 10.3473H13.8555C13.2888 10.3473 12.8271 10.809 12.8271 11.3757V13.8392C12.8271 14.4059 13.2888 14.8676 13.8555 14.8676H14.1297C14.6965 14.8676 15.1581 14.4059 15.1581 13.8392V11.3757C15.1581 10.809 14.6965 10.3473 14.1297 10.3473ZM14.2486 13.8392C14.2486 13.9078 14.1937 13.958 14.1297 13.958H13.8555C13.787 13.958 13.7367 13.9032 13.7367 13.8392V11.3757C13.7367 11.3071 13.7915 11.2569 13.8555 11.2569H14.1297C14.1983 11.2569 14.2486 11.3117 14.2486 11.3757V13.8392Z" fill="white"/>
            </svg>
            {{'PERFILCREZCAMOS.BTN_SIMULARCREDITO' | translate}}
            </button>
          </div>
          <button
            type="button"
            pButton
            class="button-comite"
            (click)="regresar()"
            icon="fa fa-arrow-left"
            label="{{ 'BTN_REGRESAR' | translate }}"
          ></button>
        </div>
      </div>
      <div class="col-12 lg:col-3"></div>
    </div>
  </div>
</div>
